import React from 'react';
import PropTypes from 'prop-types';
import { Label, Link } from 'reaxl';

// The Data Prioritization following the list.
import { jsx as _jsx } from "react/jsx-runtime";
const vhrLabels = {
  NO_ACCIDENTS_REPORTED: 'No Accidents'
};

/**
 *  Renders a vhr badge for use in InventoryListingBadges
 */
function VHRBadge(_ref) {
  let {
    vhrCode,
    listingType,
    onClick,
    vdpBaseUrl
  } = _ref;
  const label = vhrLabels[vhrCode];
  if (listingType === 'NEW' && label === vhrLabels.NO_ACCIDENTS_REPORTED) return null;
  if (!label) return null;
  return /*#__PURE__*/_jsx(Link, {
    href: `${vdpBaseUrl}#purchaseConfidence`,
    children: /*#__PURE__*/_jsx(Label, {
      bsStyle: "info-inverse",
      className: "display-inline-flex gap-1",
      "data-cmp": "vhrBadge",
      onClick: onClick,
      children: label
    })
  });
}
export default VHRBadge;